import React, { useState, useEffect, useRef } from "react";
import client from "../contentfulClient";
import { format, parseISO } from "date-fns";
import { getConfig } from "../helpers/auth-helper";
import { getSrcPath } from "../helpers/auth-helper";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
let process = {
  env: {}
};
const Raffle = _ref => {
  var _JSON$parse, _posts$fields, _posts$fields2, _posts$fields3, _posts$fields4, _posts$fields5, _posts$fields6;
  let {
    navigate
  } = _ref;
  const headerConfig = getConfig();
  const hostSrc = getSrcPath();
  const [activehistoryType, setActiveIndex] = useState(0);
  const [memberRaffles, setMemberRaffles] = useState([]);
  const [bitData, setBitData] = useState([]);
  const [skeletonLoading, setSkeletonLoading] = useState(true);
  const [posts, setPosts] = useState([]);
  const [tncData, setTncData] = useState([]);
  const [raffleCardImage, setRaffleCardImage] = useState([]);
  let memberId = localStorage.getItem("memberId");
  let memberRafflesCount = Math.trunc((_JSON$parse = JSON.parse(localStorage.getItem("memberData"))) === null || _JSON$parse === void 0 || (_JSON$parse = _JSON$parse.extra_data) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.total_raffles);
  const navigateToAllRaffles = () => {
    navigate("/allraffles");
  };
  useEffect(() => {
    const fetchPostById = async () => {
      try {
        var _entry$fields, _entry$fields2, _entry$fields3;
        const entry = await client.getEntry("6m20eSqA4lgcTn6mMSHcmD");

        // Check for linked assets or entries and resolve them
        const resolveLinks = async fields => {
          const resolvedFields = {
            ...fields
          };
          for (const key in fields) {
            const field = fields[key];
            if (Array.isArray(field)) {
              resolvedFields[key] = await Promise.all(field.map(async item => {
                if (item.sys && item.sys.type === "Link") {
                  return await client.getAsset(item.sys.id); // Resolve linked assets
                }
                return item;
              }));
            } else if (field.sys && field.sys.type === "Link") {
              if (field.sys.linkType === "Asset") {
                resolvedFields[key] = await client.getAsset(field.sys.id);
              } else if (field.sys.linkType === "Entry") {
                resolvedFields[key] = await client.getEntry(field.sys.id);
              }
            }
          }
          return resolvedFields;
        };
        const resolvedFields = await resolveLinks(entry.fields);
        setPosts({
          ...entry,
          fields: resolvedFields
        });
        // console.log({ ...entry, fields: resolvedFields })
        setTncData(resolvedFields.tnCContainer.map(item => ({
          question: item.fields.tnCTitle,
          answer: item.fields.tnCDescription,
          imgUrl: item.fields.tncImage.fields.file.url,
          fileName: item.fields.tncImage.fields.file.fileName
        })));
        // console.log(resolvedFields.tnCContainer.map((item) => ({
        //   question: item.fields.tnCTitle,
        //   answer: item.fields.tnCDescription,
        //   imgUrl: item.fields.tncImage.fields.file.url,
        //   fileName: item.fields.tncImage.fields.file.fileName
        // })))
        setRaffleCardImage([(_entry$fields = {
          ...entry,
          fields: resolvedFields
        }) === null || _entry$fields === void 0 || (_entry$fields = _entry$fields.fields) === null || _entry$fields === void 0 || (_entry$fields = _entry$fields.raffleCardBlue) === null || _entry$fields === void 0 || (_entry$fields = _entry$fields.fields) === null || _entry$fields === void 0 || (_entry$fields = _entry$fields.file) === null || _entry$fields === void 0 ? void 0 : _entry$fields.url, (_entry$fields2 = {
          ...entry,
          fields: resolvedFields
        }) === null || _entry$fields2 === void 0 || (_entry$fields2 = _entry$fields2.fields) === null || _entry$fields2 === void 0 || (_entry$fields2 = _entry$fields2.raffleCardGold) === null || _entry$fields2 === void 0 || (_entry$fields2 = _entry$fields2.fields) === null || _entry$fields2 === void 0 || (_entry$fields2 = _entry$fields2.file) === null || _entry$fields2 === void 0 ? void 0 : _entry$fields2.url, (_entry$fields3 = {
          ...entry,
          fields: resolvedFields
        }) === null || _entry$fields3 === void 0 || (_entry$fields3 = _entry$fields3.fields) === null || _entry$fields3 === void 0 || (_entry$fields3 = _entry$fields3.raffleCardGrey) === null || _entry$fields3 === void 0 || (_entry$fields3 = _entry$fields3.fields) === null || _entry$fields3 === void 0 || (_entry$fields3 = _entry$fields3.file) === null || _entry$fields3 === void 0 ? void 0 : _entry$fields3.url]);
      } catch (error) {
        console.error("Error fetching the post:", error);
      }
    };
    fetchPostById();
  }, []);
  const tabRefs = useRef([]);
  useEffect(() => {
    getRaffles({
      bitStatus: "AVAILABLE,USED,PARTIAL_USED"
    });
  }, []);
  const toggleFilter = index => {
    setSkeletonLoading(true);
    setActiveIndex(index);
    if (index == 0) {
      getRaffles({
        bitStatus: "AVAILABLE,USED,PARTIAL_USED"
      });
    } else if (index == 1) {
      getRaffles({
        bitStatus: "CANCELLED"
      });
    }
  };
  const getRaffles = async params => {
    let bitStatusParam = "";
    if (params.bitStatus && params.bitStatus != "all") {
      bitStatusParam = "&status=".concat(params.bitStatus);
    }
    const url = hostSrc + "/bolapi/v3/members/".concat(memberId, "/privileges?cdc=Raffle&page_size=5").concat(bitStatusParam, "/");
    const headers = headerConfig;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: headers
      });
      let filteredData = await response.json();
      let bitReference = filteredData.map(item => item.bit_reference);
      try {
        const fetchPromises = bitReference.map(endpoint => fetch(hostSrc + "/bolapi/v1/bits/?member_id=".concat(memberId, "&bit_id=") + endpoint, {
          method: "GET",
          headers: headers
        }).then(res => res.json()));
        const responses = await Promise.all(fetchPromises);
        // console.log(responses);
        setBitData(responses);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
      setMemberRaffles(filteredData);
      setSkeletonLoading(false);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  useEffect(() => {
    scrollToTop();
  }, []);
  function pageTitleFunc(pageTitle) {
    if (pageTitle != undefined) {
      const pageTitleVar = pageTitle.replace(/\*\*(.*?)\*\*/, "&nbsp;<p>$1</p>");
      return pageTitleVar;
    }
  }
  function pageTitleBold(pageTitle) {
    if (pageTitle !== undefined) {
      const pageTitleVar = pageTitle.replace(/__(.*?)__/g, "<b style= 'font-weight:600'>$1</b>");
      return pageTitleVar;
    }
    return ""; // Handle undefined input gracefully
  }
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 3000,
    adaptiveHeight: false,
    centerMode: false,
    variableWidth: true,
    arrows: false,
    responsive: [{
      breakpoint: 1724,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }, {
      breakpoint: 950,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }]
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "raffle-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "raffle-container-1",
    style: {
      backgroundImage: "url(".concat(posts === null || posts === void 0 || (_posts$fields = posts.fields) === null || _posts$fields === void 0 || (_posts$fields = _posts$fields.headerImage) === null || _posts$fields === void 0 || (_posts$fields = _posts$fields.fields) === null || _posts$fields === void 0 || (_posts$fields = _posts$fields.file) === null || _posts$fields === void 0 ? void 0 : _posts$fields.url, ")"),
      backgroundSize: "34%",
      backgroundRepeat: "no-repeat",
      backgroundPosition: "right 0px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "heading",
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields2 = posts.fields) === null || _posts$fields2 === void 0 ? void 0 : _posts$fields2.headerText)
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "headingDesc"
  }, posts === null || posts === void 0 || (_posts$fields3 = posts.fields) === null || _posts$fields3 === void 0 ? void 0 : _posts$fields3.headerDescription), typeof memberRafflesCount === "number" && !isNaN(memberRafflesCount) && /*#__PURE__*/React.createElement("div", {
    className: "raffleCount"
  }, /*#__PURE__*/React.createElement("div", {
    className: "raffleCount1"
  }, memberRafflesCount), /*#__PURE__*/React.createElement("div", {
    className: "raffleCount2"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "14px",
      fontWeight: "500"
    }
  }, "RAFFLES"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "10px",
      fontWeight: "300"
    }
  }, "COLLECTED SO FAR")))), /*#__PURE__*/React.createElement("div", {
    className: "raffle-container-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "tab-container",
    style: {}
  }, ["active", "expired"].map((label, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    ref: el => tabRefs.current[index] = el,
    className: activehistoryType === index ? "tab selected-tab" : "tab",
    onClick: () => toggleFilter(index)
  }, label))), skeletonLoading ? /*#__PURE__*/React.createElement("div", {
    style: {
      width: "350px",
      margin: "auto",
      padding: "20px 0"
    }
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: 165,
    width: 320,
    borderRadius: 10,
    count: 1,
    style: {
      opacity: "0.2"
    }
  })) : memberRaffles.length > 0 ? /*#__PURE__*/React.createElement(Slider, settings, memberRaffles.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: "slide"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "190px",
      width: "292px",
      backgroundImage: "url(".concat(item.status == "AVAILABLE" || item.status == "PARTIAL_USED" ? raffleCardImage[0] : item.status == "USED" ? raffleCardImage[1] : raffleCardImage[2], ")"),
      backgroundSize: "100%",
      backgroundRepeat: "no-repeat",
      flexDirection: "column",
      gap: "25px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      width: "240px",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "188px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "10px",
      letterSpacing: "1px",
      opacity: "60%",
      fontWeight: "500",
      paddingBottom: "2px"
    }
  }, "RAFFLE COLLECTED FOR:"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "12px",
      fontWeight: "400",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
      overflow: "hidden"
    }
  }, "Spending at ", bitData[index][0].sponsor_name, "!")), /*#__PURE__*/React.createElement("div", {
    style: {
      width: "32px"
    }
  }, /*#__PURE__*/React.createElement("img", {
    style: {
      maxWidth: "32px",
      maxHeight: "32px",
      borderRadius: "100%"
    },
    src: bitData[index][0].sponsor_logo
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      width: "240px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "122px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "10px",
      letterSpacing: "1px",
      opacity: "60%",
      fontWeight: "500",
      paddingBottom: "3px"
    }
  }, "STATUS"), /*#__PURE__*/React.createElement("div", {
    className: item.status == "AVAILABLE" || item.status == "PARTIAL_USED" ? "activeCta" : item.status == "USED" ? "winnerCta" : "expiredCta"
  }, item.status == "AVAILABLE" || item.status == "PARTIAL_USED" ? "ACTIVE" : item.status == "USED" ? "WINNER" : "EXPIRED")), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "10px",
      letterSpacing: "1px",
      opacity: "60%",
      fontWeight: "500",
      paddingBottom: "2px"
    }
  }, "TRANSACTION DATE"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "12px",
      fontWeight: "400"
    }
  }, new Intl.DateTimeFormat("en-US", {
    weekday: "short",
    day: "numeric",
    month: "short",
    year: "numeric"
  }).format(new Date(bitData[index][0].h_bit_date))))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      width: "240px",
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "10px",
      letterSpacing: "1px",
      opacity: "60%",
      fontWeight: "500",
      paddingBottom: "2px"
    }
  }, "TICKET ID"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "12px",
      fontWeight: "600",
      color: "#F1CB83"
    }
  }, "#", item.privilege_code))))))) : /*#__PURE__*/React.createElement("div", {
    style: {
      width: "fit-content",
      margin: "70px auto 15px",
      padding: "60px",
      border: "1px dashed rgb(173, 173, 173)",
      borderRadius: "10px",
      backgroundColor: "rgba(246, 246, 246, 0.2)"
    }
  }, "No Raffles Available") // Safe fallback content
  ), /*#__PURE__*/React.createElement("div", {
    className: "raffle-container-3",
    style: {
      backgroundImage: "url(".concat(posts === null || posts === void 0 || (_posts$fields4 = posts.fields) === null || _posts$fields4 === void 0 || (_posts$fields4 = _posts$fields4.goldenShadow) === null || _posts$fields4 === void 0 || (_posts$fields4 = _posts$fields4.fields) === null || _posts$fields4 === void 0 || (_posts$fields4 = _posts$fields4.file) === null || _posts$fields4 === void 0 ? void 0 : _posts$fields4.url, ")")
    }
  }, memberRaffles.length > 0 ? /*#__PURE__*/React.createElement("button", {
    className: "invite"
  }, /*#__PURE__*/React.createElement("div", {
    onClick: navigateToAllRaffles
  }, "View All Raffles")) : /*#__PURE__*/React.createElement("div", {
    style: {
      height: "35px"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "heading",
    style: {
      lineHeight: "30px",
      display: "block",
      width: "200px",
      flexDirection: "row",
      margin: "0 auto"
    },
    dangerouslySetInnerHTML: {
      __html: pageTitleFunc(posts === null || posts === void 0 || (_posts$fields5 = posts.fields) === null || _posts$fields5 === void 0 ? void 0 : _posts$fields5.tnCHeading)
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "raffle-container-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "raffle-container-41"
  }, tncData === null || tncData === void 0 ? void 0 : tncData.map((item, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: index
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: "48px",
      height: "48px"
    }
  }, /*#__PURE__*/React.createElement("img", {
    style: {
      width: "100%",
      maxHeight: "100%",
      objectFit: "cover"
    },
    src: item.imgUrl,
    alt: item.fileName
  })), index != Math.floor(tncData.length - 1) && /*#__PURE__*/React.createElement("div", {
    style: {
      width: "1px",
      height: "77px",
      backgroundColor: "#F1CB83",
      opacity: "20%"
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: "raffle-container-42"
  }, tncData === null || tncData === void 0 ? void 0 : tncData.map((item, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    style: {
      minHeight: "145px",
      padding: "0 18px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      color: "white",
      fontSize: "12px",
      fontWeight: "600",
      letterSpacing: "1px",
      display: "block"
    },
    dangerouslySetInnerHTML: {
      __html: pageTitleBold(item.question)
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      color: "white",
      fontSize: "14px",
      fontWeight: "300",
      display: "block",
      opacity: "60%",
      textAlign: "justify"
    },
    dangerouslySetInnerHTML: {
      __html: pageTitleBold(item.answer)
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: "14px",
      fontWeight: "300",
      padding: "0 24px 50px"
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      display: "flex",
      flexDirection: "column"
    }
  }, posts === null || posts === void 0 || (_posts$fields6 = posts.fields) === null || _posts$fields6 === void 0 || (_posts$fields6 = _posts$fields6.tnCFooter) === null || _posts$fields6 === void 0 || (_posts$fields6 = _posts$fields6.content) === null || _posts$fields6 === void 0 || (_posts$fields6 = _posts$fields6[0]) === null || _posts$fields6 === void 0 ? void 0 : _posts$fields6.content.map((node, index) => {
    if (node.nodeType === "text") {
      return /*#__PURE__*/React.createElement("span", {
        key: index
      }, node.value);
    }
    if (node.nodeType === "hyperlink") {
      return /*#__PURE__*/React.createElement("a", {
        key: index,
        href: node.data.uri,
        target: "_blank",
        rel: "noopener noreferrer",
        style: {
          color: "#F1CB83",
          textDecoration: "none"
        }
      }, node.content[0].value);
    }
    return null;
  }))));
};
export { Raffle };